import request from '@/utils/api/requestConfig'

export function sendSms(data) {
  return request({
    url: '/teachpoint/sendSms',
    method: 'post',
    data
  })
}

export function registerBranchInfo(data) {
  return request({
    url: '/teachpoint/registerBranchInfo',
    method: 'post',
    data
  })
}
export function getSsq(data) { // 获取省市区， 获取省不需要传code_id
  return request({
    url: '/base/listSsq',
    method: 'post',
    data
  })
}

//验证短信验证码
export function checkTelCode(data) {
  return request({
    url: '/teachpoint/checkTelCode',
    method: 'post',
    data
  })
}
//2.3.108验证此单位名称是否已经提交过申请
export function checkSqdw(data) {
  return request({
    url: '/teachpoint/checkSqdw',
    method: 'post',
    data
  })
}
//教学点申请资料填写
export function applyBranchInfo(data) {
  return request({
    url: '/teachpoint/applyBranchInfo',
    method: 'post',
    isFormData: 'file',
    data
  })
}
//获取各种码表
export function droplist(data) {
  return request({
    url: '/base/droplist',
    method: 'post',
    data
  })
}

// 教学点申请进度信息列表
export function queryApplyInfoList(data) {
  return request({
    url: '/teachpoint/queryApplyInfoList',
    method: 'post',
    data
  })
}

// 2修改教学点申请资料
export function updateApplyBranchInfo(data) {
  return request({
    url: '/teachpoint/updateApplyBranchInfo',
    method: 'post',
    isFormData: 'file',
    data
  })
}
// 删除教学点申请
export function deleteApplyInfo(data) {
  return request({
    url: '/teachpoint/deleteApplyInfo',
    method: 'post',
    data
  })
}
// 2.3.114扫描文档上传
export function uploadApplyPdf(data) {
  return request({
    url: '/teachpoint/uploadApplyPdf',
    method: 'post',
    isFormData: 'file',
    data
  })
}

// 验证手机号是否已经信息注册
export function checkIfRegister(data) {
  return request({
    url: '/teachpoint/checkIfRegister',
    method: 'post',
    data
  })
}

//查询教学点申请须知
export function querySchoolbranchNotice(data) {
  return request({
    url: '/teachpoint/querySchoolbranchNotice',
    method: 'post',
    data
  })
}
// 类别下拉框
export function getBranchType(data) {
  return request({
    url: '/teachpoint/getBranchType',
    method: 'post',
    data
  })
}
//验证是否注册
export function checkTel(data) {
  return request({
    url: '/teachpoint/checkTel',
    method: 'post',
    data
  })
}
// 教学点申请暂存信息回显
export function queryApplyInfoZc(data) {
  return request({
    url: '/teachpoint/queryApplyInfoZc',
    method: 'post',
    data
  })
}

// 老师手机号登录 
export function teacherTelLogin(data) {
  return request({
    url: '/teachpoint/teacherTelLogin',
    method: 'post',
    data
  })
}
// 申请模板查询
export function queryApplyTemplate(data) {
  return request({
    url: '/teachpoint/queryApplyTemplate',
    method: 'post',
    data
  })
}
